const d = 'm313-435 232 233-64 63-342-342 341-341 65 64-232 232h509v91H313Z';

export default d;
